import { format } from 'date-fns';
import { RequestManager } from '../../../../utilities/request';

export const refuelEuEligibilityOptions = [
	{ value: 'YES', title: 'Yes' },
	{ value: 'NO', title: 'No' },
];

export const getRefuelEuDate = (date: any, formatString = 'yyyy. MM. dd. HH:mm') => {
	if (!date) {
		return '-';
	}

	return format(new Date(date), formatString);
};

export const getRefuelEuStatus = (isEligible: string) =>
	isEligible === 'YES' ? 'Eligible' : 'Not eligible';

export const getRefuelEuColor = (isEligible: string) =>
	isEligible === 'YES' ? 'green-2' : 'red-2';

export const getAirportRefuelEuByAid = async (aid: string) =>
	await RequestManager.get(`/airportrefueleus/${aid}`);

const normalizeResponse = (response) => {
	if (!response) {
		return null;
	}

	if (Array.isArray(response)) {
		return response[0] || null;
	}

	if (Array.isArray(response?.content)) {
		return response?.content?.[0] || null;
	}

	if (response?.aid || response?.isEligible) {
		return response;
	}

	return null;
};

const getParentAid = (item: any) =>
	item?.parent?.aid ||
	item?.parent?.entityAid ||
	item?.parentEntity?.aid ||
	item?.parentEntity ||
	item?.parent ||
	null;

export const getAirportRefuelEuByAirportAid = async (airportAid: string) => {
	const response = await RequestManager.get(
		`/airports/${airportAid}/airportRefuelEu/all`
	);

	const items = Array.isArray(response) ? response : [];
	const item =
		items.find((entry: any) => getParentAid(entry) === airportAid) ||
		items[0] ||
		null;

	return normalizeResponse(item);
};
